import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import axios from "axios";
import { AppContext } from "../../context/Appcontext";
import "../../assests/css/students/eventpage/eventgallery.css";

function EventGallery() {
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);

  const [galleryImages, setGalleryImages] = useState([]); // [{ image, caption }]
  const [selectedImage, setSelectedImage] = useState(null);

  // Backend se saare events lao, phir har event ki gallery ko combine kero
  const fetchGalleryImages = () => {
    axios
      .get(`${baseUrl}/admin/events/viewAllEvents`)
      .then((response) => {
        const events = response.data.events || [];

        // Har event ke gallery array ko ek single flat array mein merge kero
        const combinedGallery = events.reduce((acc, event) => {
          if (event.gallery?.length) {
            const items = event.gallery.map((g) => ({
              image: g.image,
              caption: g.caption || "",
            }));
            return [...acc, ...items];
          }
          return acc;
        }, []);

        setGalleryImages(combinedGallery);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchGalleryImages();
  }, []);

  const openLightbox = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  // Agar koi gallery image na ho to section hi na dikhaye
  if (galleryImages.length === 0) {
    return null;
  }

  return (
    <section className="eg-gallery-section">
      <Container>
        <Row>
          <Col className="text-center">
            <h2 className="eg-section-heading">Event Gallery</h2>
            <p className="eg-section-subheading">
              A quick glimpse into the moments from our previous events
            </p>
          </Col>
        </Row>

        <div className="eg-gallery-grid">
          {galleryImages.map((item, index) => {
            const fullImageUrl = `${baseUrlForFiles}/${item.image}`;
            return (
              <div
                key={index}
                className="eg-gallery-item"
                onClick={() => openLightbox(fullImageUrl)}
              >
                <img
                  src={fullImageUrl}
                  alt={item.caption || `Gallery ${index + 1}`}
                  className="eg-gallery-img"
                />

                <div className="eg-gallery-overlay">
                  {/* <span className="eg-gallery-icon">🔍</span> */}
                </div>
              </div>
            );
          })}
        </div>
      </Container>

      <Modal
        show={selectedImage !== null}
        onHide={closeLightbox}
        centered
        size="lg"
        className="eg-lightbox-modal"
      >
        <Modal.Body className="eg-lightbox-body">
          {selectedImage && (
            <img
              src={selectedImage}
              alt="Selected gallery"
              className="eg-lightbox-img"
            />
          )}
        </Modal.Body>
      </Modal>
    </section>
  );
}

export default EventGallery;